import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TicketRequest } from '../models/ticketOrder';

@Injectable({
  providedIn: 'root',
})
export class BenefitsService {
  private apiUrl = environment.backWallet;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
  }

  createTicket(ticketData: TicketRequest): Observable<any> {
    //console.log('Submitting ticket order');
    const headers = this.getAuthHeaders();
    return this.http.post(`${this.apiUrl}/company/create-ticket`, ticketData, {
      headers,
    });
  }

  //merchant compensation
  requestCompensation(ticketData: TicketRequest): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(`${this.apiUrl}/merchant/compensation`, ticketData, {
      headers,
    });
  }
}
